module.exports = __webpack_public_path__ + "static/media/MedicineDelivery_icon.60c6d87e.png";